import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useJobApplicationsFilter } from './useJobApplicationsFilter';

export const JobApplicationsFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, jobApplicationsOptions } = useJobApplicationsFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ jobApplications: value || jobApplicationsOptions[0] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="jobApplications"
          label="Job applications"
          placeholder="Include"
          size="small"
          component={FormSelect}
          options={jobApplicationsOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

JobApplicationsFilter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
  setFilters: PropTypes.func.isRequired,
};

JobApplicationsFilter.defaultProps = {
  value: null,
};
